:host {
  display: block;

  .top-100 {top: 100%}
  .bottom-100 {bottom: 100%}
  .max-h-select {
    max-height: 300px;
  }
}

.nest-select {
  @apply flex flex-col relative cursor-pointer;

  &__label {
    @apply mb-1 mt-2 text-foreground;
  }

  &__control {
    @apply w-full my-1 bg-background px-2 py-1 flex border border-input rounded;
  }
}
